import {
  SearchApiModel,
  useAxios,
  useDeleteNulls,
  useHandleApiError,
} from '@sttedra_ui/framework';

import TouristRouteApiResponseModel from './tourist-route.api-response-model.js';
import TouristRouteStopsApiResponseModel from './tourist-route-stops.api-response-model.js';

// #region Globals
const {base} = useAxios();
const CONTEXT_BASE_PATH = 'rutasturisticas';
const DEFAULT_TIMEOUT = 5000;
const {handleApiError} = useHandleApiError();
// #endregion

// #region Public functions

async function searchTouristRoute(searchParams = {}, throwError = true) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = '/' + CONTEXT_BASE_PATH;

    const {data: response} = await base.post(url, searchModel, {
      timeout: DEFAULT_TIMEOUT,
    });

    const {data: originalData, pageSize, pageIndex, totalResults} = response;

    const data = originalData.map((u) => new TouristRouteApiResponseModel(u));

    return {data, pageSize, pageIndex, totalResults};
  } catch (err) {
    if (!throwError) {
      return handleApiError(err);
    }
    throw err;
  }
}

async function viewTouristRoutePdf(id, throwError = true) {
  try {
    const url = '/' + CONTEXT_BASE_PATH + '/' + id + '/pdf';

    const {data} = await base
      .get(url, {
        timeout: DEFAULT_TIMEOUT,
      });

    window.open(data);
  } catch (err) {
    if (!throwError) {
      return handleApiError(err);
    }
    throw err;
  }
}

async function searchTouristRouteStops(id) {
  try {
    const selectedId = !!id ? id : 0;
    const url = '/' + CONTEXT_BASE_PATH + '/' + selectedId + '/paradas';

    const {data: response} = await base.post(url, {}, {
      timeout: DEFAULT_TIMEOUT,
    });
    const {data: originalData, pageSize, pageIndex, totalResults} = response;
    const data = originalData.map((u) => new TouristRouteStopsApiResponseModel(u));

    return {data, pageSize, pageIndex, totalResults};
  } catch (err) {
    return handleApiError(err);
  }
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  searchTouristRoute, viewTouristRoutePdf, searchTouristRouteStops,
};
